
import { Block } from "baseui/block";
import { AddObject } from '../../ObjectCreator/AddObject'
import { useState } from 'react'
import ObjectsSelectView, { onParentChangedArgs } from '../ObjectsSelectView';
import { IAutomationObject } from '../../../automationObjects';
import { Banner } from "baseui/banner";
import { ButtonGroup, MODE } from "baseui/button-group";
import { Button, SIZE } from "baseui/button";

export interface ObjectNavigatorProps {
    onSelected: any,
    showAddObject?: boolean,
    currentSelectedParent?:IAutomationObject,
    filter?: (app: IAutomationObject) => boolean | undefined,
}

const ObjectNavigator = ({ onSelected, showAddObject, currentSelectedParent, filter }: ObjectNavigatorProps) => {

    const [parentId, setParentId] = useState({ id: '', resourceGroupId: '' });
    const [refetchCount, setRefetchCount] = useState(0);

    const [view, setView] = useState(0);

    const [selectedItem, setSelectedItem] = useState<IAutomationObject>();
    

    function onSelectedItemChanged(item: IAutomationObject) {
        onSelected(item);
        setSelectedItem(item);
    }
    function onParentChanged(args: onParentChangedArgs) {
        if (args)
            setParentId(prevState => { return { id: args.id, resourceGroupId: args.resourceGroupId } });
        else
            setParentId(prevState => { return { id: '', resourceGroupId: '' } });
    }
    function onCloseAddObject() {
        setRefetchCount(prev => {
            return prev + 1
        });
    }

    return (
        <Block marginTop='20px' display='flex' flexDirection='column' justifyContent='flex-start' gridRowGap={'20px'}>
            
            <ObjectsSelectView filter={filter} showSystemApps={view === 1} refetchCount={refetchCount} onSelectedItemChanged={onSelectedItemChanged} onParentChanged={onParentChanged} currentSelectedParent={currentSelectedParent}></ObjectsSelectView>
            {showAddObject && <Block display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
                <Banner>Object missing? Click the + to add a new one</Banner>
                <div>
                    <AddObject onClose={onCloseAddObject} object={selectedItem}></AddObject>
                </div>
            </Block>}
        </Block>
    )
}
export default ObjectNavigator




/*

<ButtonGroup
                mode={MODE.radio}
                selected={view}
                onClick={(_event, index) => {
                    setView(index);
                }}
                size={SIZE.compact}
                kind="secondary"
            >
                <Button>Apps</Button>
                <Button >System Apps</Button>
            </ButtonGroup>
            */